module.exports = {
	"Play": "Play",
	"Pause": "Pause",
	"Current Time": "Current Time",
	"Duration Time": "Duration Time",
	"Remaining Time": "Remaining Time",
	"Stream Type": "Stream Type",
	"LIVE": "LIVE",
	"Loaded": "Loaded",
	"Progress": "Progress",
	"Fullscreen": "Fullscreen",
	"Non-Fullscreen": "Non-Fullscreen",
	"Mute": "Mute",
	"Unmute": "Unmute",
	"Playback Rate": "Playback Rate",
	"Subtitles": "Subtitles",
	"subtitles off": "subtitles off",
	"Captions": "Captions",
	"captions off": "captions off",
	"Chapters": "Chapters",
	"Close Modal Dialog": "Close Modal Dialog",
	"Descriptions": "Descriptions",
	"descriptions off": "descriptions off",
	"Audio Track": "Audio Track",
	"You aborted the media playback": "You aborted the media playback",
	"A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
	"No compatible source was found for this media.": "No compatible source was found for this media.",
	"The media is encrypted and we do not have the keys to decrypt it.": "The media is encrypted and we do not have the keys to decrypt it.",
	"Play Video": "Play Video",
	"Close": "Close",
	"Modal Window": "Modal Window",
	"This is a modal window": "This is a modal window",
	"This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
	", opens captions settings dialog": ", opens captions settings dialog",
	", opens subtitles settings dialog": ", opens subtitles settings dialog",
	", opens descriptions settings dialog": ", opens descriptions settings dialog",
	", selected": ", selected"
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/en.json
// module id = 1578
// module chunks = 2